import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, RadioGroup, Radio, Switch, Typography
} from '@mui/material';
import Add from '@mui/icons-material/Add';

import CustomerList from './CustomerList';
import PageTitle from '../ui/PageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();
const CustomersQuery = graphql`
query CustomersQuery($resellerAccountId: UUID!, $accountName: String!, $accountNumber: String!, $activeOnly: Int,  $floatProblemOnly: Int, $outstandingSOOnly: Int, $orderBy: Int, $direction: Int, $first: Int, $offset: Int) {
  accountsearchforcustomer4(reselleraccountid: $resellerAccountId, accountname: $accountName, accountnumber: $accountNumber, activeonly: $activeOnly, floatproblemonly: $floatProblemOnly, outstandingsoonly: $outstandingSOOnly, orderby: $orderBy, direction: $direction, first: $first, offset: $offset) {
    totalCount
    ...CustomerList_cl
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.background.default,
  },
  flex: {
    flex: 1,
  },
  appDiv: {
    marginTop: 8
  },
  radio: {
    marginTop: 16
  },
  formControl: {
    marginTop: '24',
  },
  nselect: {
    minWidth: 150
  }
});

class Customers extends Component {
  state = {
    customerName: '',
    customerNum: '',
    activeOnly: 1,
    floatProblemOnly: 0,
    outstandingSOOnly: 0,
    orderBy: 0,
    mountComplete: 0

  };

  componentDidMount() {
    if (abEnvironment.isSegmentActive()) { window.analytics.page(); }

    const params = new URLSearchParams(this.props.location.search);
    let sTerm = params.get('sterm');
    if (sTerm !== null) {
      //backward compatibility if any
      this.setState({customerName: sTerm, mountComplete: 1});
    } else {
       // Is there something in local storage?
       sTerm = localStorage.getItem('customersSterms');
       if (sTerm !== null) {

        try {
          var searchTerms = JSON.parse(sTerm);
          this.setState({customerName: searchTerms.customerName, customerNum: searchTerms.customerNum, activeOnly: searchTerms.activeOnly, floatProblemOnly: searchTerms.floatProblemOnly, orderBy: searchTerms.orderBy, mountComplete: 1});
        } catch (error) {
          //console.log(error);
        }

      } else {
        this.setState({mountComplete: 1});
      }
  
    }

  }

  goTo(route) {

    var searchToSave = {customerName: this.state.customerName, customerNum: this.state.customerNum, activeOnly: this.state.activeOnly, floatProblemOnly: this.state.floatProblemOnly, orderBy: this.state.orderBy}
    var searchTerms = JSON.stringify(searchToSave);
    localStorage.setItem('customersSterms', searchTerms);
    this.props.history.push(`/${route}`);
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleOrderByChange = (event) => {

    
    this.setState({'orderBy': parseInt(event.target.value, 10)});
 
  };

  render() {
    const { isAuthenticated, isAuthenticatedReseller, isAccountSuspended, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    let numberToShow = 24;

    // Experiences for different personas...
    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }
    else if (isAuthenticatedReseller()) {

      let accountId = abEnvironment.getUserAttribute('a_id');

      // Check if there is a FreshBooks integration active.
      let freshBooksActive = false;
      let integratedApps = abEnvironment.getUserAttribute('a_integrations');
      if (integratedApps != null && (integratedApps === 'FreshBooks' || integratedApps.includes('FreshBooks'))) {
        // Show a button
        freshBooksActive = true;
      }

      if (this.state.mountComplete === 1) {
        var searchToSave = {customerName: this.state.customerName, customerNum: this.state.customerNum, activeOnly: this.state.activeOnly, floatProblemOnly: this.state.floatProblemOnly, orderBy: this.state.orderBy}
        var searchTerms = JSON.stringify(searchToSave);
        localStorage.setItem('customersSterms', searchTerms);
      }

      return (
        <React.Fragment>
          <PageTitle title="Customers" subtitle="Create and manage app subscriptions for your customers."/>
          <Grid container spacing={1} direction="row" justifyContent="flex-start" style={{marginTop: '-24px'}}>
            <Grid item xs={12}>
              <Grid container spacing={1} justifyContent="flex-start">
                <Grid item>
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={isAccountSuspended()}
                    style={AppBindStyles.addButtonOnSearch}
                    onClick={() => {this.goTo('customercreate');}}
                  >
                    <Add/>Add Customer
                  </Button>
                </Grid>
                {freshBooksActive === true &&
                <Grid item>
                  <Button
                    color="primary"
                    variant="outlined"
                    disabled={isAccountSuspended()}
                    style={AppBindStyles.addButtonOnSearch}
                    onClick={() => {this.goTo('customerimport');}}
                  >
                    <Add/>Import from FreshBooks
                  </Button>
                </Grid>}
              </Grid>
            </Grid>
            <Grid item>
              <SearchField
                id="customer-name-search"
                label="Search by customer name"
                value={this.state.customerName}
                onChange={this.handleChange('customerName')}
              />
            </Grid>
            <Grid item>
              <SearchField
                id="customer-num-search"
                label="Search by customer identifier"
                value={this.state.customerNum}
                onChange={this.handleChange('customerNum')}
              />
            </Grid>
            <Grid item>
              <FormControlLabel style={{marginTop: '16px'}}
                control={
                  <Switch
                    checked={this.state.activeOnly !== 1}
                    onChange={(e, checked) => {
                      if (this.state.activeOnly === 1) {
                        //console.log('setting state to 0');
                        this.setState({ activeOnly: 0, page: 0});
                      } else {
                        //console.log('setting state to 1');
                        this.setState({ activeOnly: 1, page: 0});
                      }
                    }}
                  />
                }
                label="Show inactive"
              />
            </Grid>
            <Grid item>
              <FormControlLabel style={{marginTop: '16px'}}
                control={
                  <Switch
                    checked={this.state.floatProblemOnly === 1}
                    onChange={(e, checked) => {
                      if (this.state.floatProblemOnly === 1) {
                        //console.log('setting state to 0');
                        this.setState({ floatProblemOnly: 0, outstandingSOOnly: 0, page: 0});
                      } else {
                        //console.log('setting state to 1');
                        this.setState({ floatProblemOnly: 1, outstandingSOOnly: 0, page: 0});
                      }
                    }}
                  />
                }
                label="Funding issues only"
              />
            </Grid>
            <Grid item className={classes.formControl}>
              <FormControl variant="standard" style={{marginTop: '4px'}}>
                <InputLabel shrink htmlFor="outstandingSO"></InputLabel>
                <Select
                  value={this.state.outstandingSOOnly}
                  inputProps={{
                    name: 'outstandingSOOnly',
                    id: 'outstandingSOOnly',
                  }}
                  onChange={(e) => { this.setState({ outstandingSOOnly: e.target.value, floatProblemOnly: 0, page: 0 }); } }
                  className={classes.nselect}
                >
                  <MenuItem value={0}>Any order status</MenuItem>
                  <MenuItem value={1}>No order sent</MenuItem>
                  <MenuItem value={2}>Outstanding order</MenuItem>
                  <MenuItem value={3}>Accepted order</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item className={classes.radio}>
                <FormControl component="fieldset">
                  <RadioGroup row aria-label="passToClient" name="passToClient" value={this.state.orderBy} onChange={(e) => this.handleOrderByChange(e)}>
                    <FormControlLabel value={0} control={<Radio />} label="Sort by name" />
                    <FormControlLabel value={1} control={<Radio />} label="Sort by identifier" />
                  </RadioGroup>
                </FormControl>
             </Grid>
          </Grid>

          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={CustomersQuery}
            variables={{resellerAccountId: accountId,
                        accountName: this.state.customerName,
                        accountNumber: this.state.customerNum,
                        activeOnly: this.state.activeOnly,
                        floatProblemOnly: this.state.floatProblemOnly,
                        outstandingSOOnly: this.state.outstandingSOOnly,
                        orderBy: this.state.orderBy,
                        direction: 1,
                        first: numberToShow}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
            } else if (props) {
                return (
                  <div className={classes.appDiv}>
                    {
                      (this.state.customerName.length === 0 && this.state.customerNum.length === 0) &&
                      props.accountsearchforcustomer4.totalCount === 0 && (
                        <Typography>No customers</Typography>
                      )
                    }
                    {
                      (this.state.customerName.length > 0 || this.state.customerNum.length > 0) &&
                      props.accountsearchforcustomer4.totalCount === 0 && (
                        <Typography>No matching customers</Typography>
                      )
                    }
                    {
                      (this.state.customerName.length === 0 && this.state.customerNum.length === 0) &&
                      props.accountsearchforcustomer4.totalCount === 1 && (
                        <Typography>1 customer</Typography>
                      )
                    }
                    {
                      (this.state.customerName.length > 0 || this.state.customerNum.length > 0) &&
                      props.accountsearchforcustomer4.totalCount === 1 && (
                        <Typography>1 matching customer</Typography>
                      )
                    }
                    {
                      (this.state.customerName.length === 0 || this.state.customerNum.length === 0) &&
                      props.accountsearchforcustomer4.totalCount > 1 &&
                      props.accountsearchforcustomer4.totalCount > numberToShow && (
                        <Typography>Showing {numberToShow} of {props.accountsearchforcustomer4.totalCount} customers</Typography>
                      )
                    }
                    {
                      (this.state.customerName.length === 0 && this.state.customerNum.length === 0) &&
                      props.accountsearchforcustomer4.totalCount > 1 &&
                      props.accountsearchforcustomer4.totalCount <= numberToShow && (
                        <Typography>{props.accountsearchforcustomer4.totalCount} customers</Typography>
                      )
                    }
                    {
                      (this.state.customerName.length > 0 || this.state.customerNum.length > 0)  &&
                      props.accountsearchforcustomer4.totalCount > 1 &&
                      props.accountsearchforcustomer4.totalCount > numberToShow && (
                        <Typography>Showing {numberToShow} of {props.accountsearchforcustomer4.totalCount} matching customers</Typography>
                      )
                    }
                    {
                      (this.state.customerName.length > 0 || this.state.customerNum.length > 0) &&
                      props.accountsearchforcustomer4.totalCount > 1 &&
                      props.accountsearchforcustomer4.totalCount <= numberToShow && (
                        <Typography>{props.accountsearchforcustomer4.totalCount} matching customers</Typography>
                      )
                    }
                    <CustomerList cl={props.accountsearchforcustomer4} sterm={searchTerms} history={this.props.history}/>
                  </div>
                )
              }
              return (
                <div className={classes.appDiv}>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
      </React.Fragment>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

Customers.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Customers);
